export default __webpack_public_path__ + "static/sverige-fokuserar-pa-bra-upplevelse-i-mobilen-9de8aec0dbdba246d4c1dbea938f59fe.jpg";